import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Button, Collapse } from 'react-bootstrap';
import cx from 'classnames';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import ListItem from './ListItem';

import { contactHostOpen } from '../../../actions/message/contactHostModal';
import { checkValue } from './helper';
import { getDynamicDescription, getDynamicName } from '../../../helpers/GetDynamicItemName/getDynamicName';
import messages from '../../../locale/jsonMessages';

//Images
import arrowIcon from '/public/SiteIcons/listArrowLeft.svg';
import { ShowLessSvgIcon, ShowMoreSvgIcon } from '../../Common/Assets/SvgIconComponent/CommonSvgIcon';

import cs from '../../../components/commonStyle.css';
import s from './ListingDetails.css';

class ListingDetails extends React.Component {
  static propTypes = {
    data: PropTypes.shape({
      listingData: PropTypes.shape({
        cancellation: PropTypes.shape({
          policyName: PropTypes.string.isRequired,
          policyContent: PropTypes.string.isRequired
        })
      })
    }),
    getSpecificSettings: PropTypes.any,
    settingsData: PropTypes.object,
    isHost: PropTypes.bool.isRequired,
    formatMessage: PropTypes.any,
    userBanStatus: PropTypes.number,
  };
  static defaultProps = {
    isHost: false,
    description: []
  };

  constructor(props) {
    super(props);
    this.state = {
      open: false,
    }
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.setState({ open: !this.state.open })
  }


  render() {
    const { data, locale, dynamicLanguageData, dynamicListDescription, listingFields } = this.props;
    const { open } = this.state;
    const { formatMessage } = this.props.intl;
    let minDay, maxDay, checkInStart, checkInEnd, propertyType, roomType,
      userAmenities = [], userSafetyAmenities = [], amenities = [],
      sharedSpaces = [], houseRules = [], bedTypes = [],
      description, personCapacity, bathrooms, bedrooms, beds,
      dynamicMinNight, dynamicMaxNight;
    let dynamicDescription = getDynamicDescription({ data: dynamicListDescription, locale, id: data.id });
    if (data?.listingData != undefined) {
      minDay = checkValue(data?.listingData?.minDay, 0);
      maxDay = checkValue(data?.listingData?.maxDay, 0);
      checkInStart = checkValue(data?.listingData?.checkInStart, '');
      checkInEnd = checkValue(data?.listingData?.checkInEnd, '');
    }
    if (data?.settingsData != undefined && data?.settingsData?.length > 0) {
      propertyType = checkValue(data?.settingsData && data?.settingsData[1]?.listsettings?.itemName, '');
      roomType = checkValue(data?.settingsData && data?.settingsData[0]?.listsettings?.itemName, '');
    }
    sharedSpaces = checkValue(data?.userSpaces, []);
    houseRules = checkValue(data?.houseRules, []);
    userAmenities = checkValue(data?.userAmenities, []);
    userSafetyAmenities = checkValue(data?.userSafetyAmenities, []);
    description = checkValue(dynamicDescription || data?.description, '');
    personCapacity = checkValue(data?.personCapacity, 0);
    bathrooms = checkValue(data?.bathrooms, 0);
    bedrooms = checkValue(data?.bedrooms, 0);
    beds = checkValue(data?.beds, 0);
    bedTypes = checkValue(data?.userBedsTypes, []);

    let count = 150, firstArray, restArray, dotString = false;
    if (description) {
      firstArray = description.slice(0, count);
      restArray = description.slice(count, description.length);
    }
    if (restArray?.length > 0) {
      dotString = true;
    }

    let carRules = houseRules?.length > 0 ? houseRules.filter(o => o?.listsettings?.isEnable == "1") : [];

    let carFeatures = userAmenities?.length > 0 ? userAmenities.filter(o => o?.listsettings?.isEnable == "1") : [];
    dynamicMinNight = getDynamicName({ value: listingFields?.minNight[0], locale, data: dynamicLanguageData })
    dynamicMaxNight = getDynamicName({ value: listingFields?.maxNight[0], locale, data: dynamicLanguageData })

    return (
      <div>
        <>
          <h5 className={cx(cs.commonSubTitleText, cs.fontWeightBold, cs.paddingBottom3)}>
            <FormattedMessage {...messages.aboutListing} />
          </h5>
          <div>
            <p className={cs.commonContentText}>
              {!this.state.open && count >= 150 && dotString === true &&
                <span>{firstArray} ...</span>
              }
              {!this.state.open && count >= 150 && dotString === false &&
                <span>{firstArray}</span>
              }
              {
                restArray?.length > 0 &&
                <span>
                  <Collapse in={open}>
                    <div>
                      {firstArray}{restArray}
                    </div>
                  </Collapse>
                  {
                    dotString &&
                    <div className={cs.paddingTop2}>
                      <Button
                        bsStyle="link"
                        className={s.showHideBtn}
                        onClick={() => this.handleClick()}
                      >
                        {this.state.open ? <FormattedMessage {...messages.closeAllLabel} /> : <FormattedMessage {...messages.showMore} />}

                        {
                          this.state.open && <ShowLessSvgIcon />
                        }

                        {
                          !this.state.open && <ShowMoreSvgIcon />
                        }

                      </Button>
                    </div>
                  }
                </span>
              }
            </p>
          </div>
        </>
        <hr className={cs.listingHorizoltalLine} />
        {
          sharedSpaces?.length > 0 && <>
            <ListItem
              itemList={sharedSpaces}
              label={formatMessage(messages.sharedSpaces)}
              showLabel={formatMessage(messages.showMore)}
              hideLabel={formatMessage(messages.closeAllLabel)}
              className={s.listItemSection}
              locale={locale}
              dynamicLanguageData={dynamicLanguageData}
            />

          </>
        }

        {
          carFeatures?.length > 0 && <>
            <ListItem
              itemList={userAmenities}
              label={formatMessage(messages.carFeatures)}
              showLabel={formatMessage(messages.showMore)}
              hideLabel={formatMessage(messages.closeAllLabel)}
              className={s.listItemSection}
              locale={locale}
              dynamicLanguageData={dynamicLanguageData}
            />
          </>
        }

        {
          carRules?.length > 0 && <>
            <ListItem
              itemList={houseRules}
              label={formatMessage(messages.houseRules)}
              showLabel={formatMessage(messages.showMore)}
              hideLabel={formatMessage(messages.closeAllLabel)}
              locale={locale}
              dynamicLanguageData={dynamicLanguageData}
            />
          </>
        }

        {
          userSafetyAmenities?.length > 0 && <>
            <ListItem
              itemList={userSafetyAmenities}
              label={formatMessage(messages.safetyFeatures)}
              showLabel={formatMessage(messages.showMore)}
              hideLabel={formatMessage(messages.closeAllLabel)}
            />
          </>
        }

        {
          ((minDay != null && minDay) || (maxDay != null && maxDay > 0)) && <>
            <h6 className={cx(cs.commonSubTitleText, cs.fontWeightBold)}><FormattedMessage {...messages.availability} /></h6>
            <div className={s.minMaxSection}>
              {
                minDay != null && minDay > 0 &&
                <p className={cx(cs.commonContentText, s.displayFlex, cs.paddingTop3)}>
                  <img src={arrowIcon} className={cx(s.streeingImage, 'commonIconSpace')} />
                  <span>
                    <span className={cs.fontWeightBold}>{minDay}   {minDay > 1 ? dynamicMinNight?.otherItemName : dynamicMinNight?.itemName}</span>
                  </span>
                </p>
              }
              {
                maxDay != null && maxDay > 0 &&
                <p className={cx(cs.commonContentText, s.displayFlex, cs.paddingTop3)}>
                  <img src={arrowIcon} className={cx(s.streeingImage, 'commonIconSpace')} />
                  <span>
                    <span className={cs.fontWeightBold}>{maxDay}  {maxDay > 1 ? dynamicMaxNight?.otherItemName : dynamicMaxNight?.itemName} </span>
                  </span>
                </p>
              }
            </div>
            <hr className={cs.listingHorizoltalLine} />
          </>
        }
      </div>
    );
  }
}
const mapState = (state) => ({
  settingsData: state?.viewListing?.settingsData,
  locale: state?.intl?.locale,
  dynamicLanguageData: state?.dynamicListSettings?.data,
  dynamicListDescription: state?.dynamicListTitles?.data?.dynamicListDescription,
  listingFields: state?.listingFields?.data,
});
const mapDispatch = {
  contactHostOpen
};
export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(ListingDetails)));